const puzzle = `A	M	C	M	K	B	P	B	O	K	F	Ö	R	I	N	G	Ä	H	S	L	V
B	A	K	N	A	F	S	I	K	B	Ö	V	E	R	S	K	O	T	T	Y	C
A	R	B	E	T	S	G	I	V	A	R	A	V	G	I	F	T	K	V	J	Ä
A	K	T	I	E	B	O	L	A	G	E	B	T	Y	H	R	M	C	X	L	T
Y	N	S	R	M	L	O	G	I	S	T	I	K	Ä	K	A	M	P	A	N	J
U	A	B	H	K	E	H	C	S	N	A	R	B	A	X	N	I	B	N	Å	R
I	D	R	E	V	D	Y	K	L	T	G	I	R	B	Y	C	A	E	N	M	Y
O	C	X	L	F	N	A	G	R	O	S	S	I	S	T	H	E	U	O	N	A
P	K	V	A	L	I	T	E	T	B	O	K	T	S	N	I	V	I	N	B	W
Å	O	V	U	I	N	A	S	G	F	R	J	Ö	N	B	S	I	R	S	C	F
Ä	M	X	T	Y	G	C	E	R	T	I	F	I	E	R	I	N	G	E	M	P
L	P	S	V	B	S	K	O	U	R	E	D	P	Å	X	N	A	B	R	O	L
K	A	M	C	K	G	O	K	K	U	N	D	E	R	V	G	S	P	I	Å	M
J	N	F	O	X	R	N	A	Ö	R	T	I	D	E	R	K	O	M	N	G	P
H	J	W	Z	A	U	K	L	K	R	E	V	I	S	I	O	N	O	G	Y	S
K	O	N	T	O	P	U	N	D	E	R	L	E	V	E	R	A	N	T	Ö	R
G	N	I	O	U	P	R	I	S	B	I	L	D	G	J	Ö	W	O	A	S	O
F	P	E	S	L	E	R	Y	T	S	N	A	T	Y	S	H	I	P	O	P	Y
D	A	B	C	D	E	E	F	G	H	G	L	T	U	L	S	K	O	B	S	I
S	C	Ä	Y	B	R	N	O	Å	T	E	T	P	G	K	I	Y	L	A	Ä	Z
A	P	K	L	O	N	T	M	T	Y	N	A	P	Å	E	W	Q	R	R	T	I`


function transformRow(row) {
  row = row.replace(/\s/g, '')
  return Array.from(row).map(l => l.toLowerCase())
}

export function generatePuzzle() {
  return puzzle.split("\n").map(row => transformRow(row))
}

export const words = [
  'Aktiebolag',
  'Bokföring',
  'Arbetsgivaravgift',
  'Styrelse',
  'Ledningsgrupp',
  'Underleverantör',
  'Marknad',
  'Konkurrent',
  'Bokslut',
  'Bransch',
  'Franchising',
  'Certifiering',
  'Monopol',
  'Företagsorienteringen',
  'Grossist',
  'Kunder',
  'Kvalitet',
  'Risk',
  'Kampanj',
  'Annonsering',
  'Kompanjon',
  'Vinst',
  'Revision',
  'Kredit',
  'Logistik',
  'Överskott'
]
